<template>
  <v-data-table
    class="nowrap"
    v-model="selected"
    :headers="headers"
    leading-text="đang tải..."
    no-data-text="không có chi phí cần đóng"
    :items="leads"
    item-key="name"
    :loading="loading"
    @click:row="selectLead"
  >
    <template v-slot:top>
      <autocomplete-student
        v-model="student"
        placeholder="Tìm kiếm học sinh"
        label="Học Sinh"
        dense
        outlined
        return-object
        @change="selectStudent"
      />
    </template>
    <template v-slot:item.total="{ item }">
      <div class="text-right body-2 font-weight-black">
        {{ item.total | formatMoney }}
      </div>
    </template>
    <template v-slot:item.liabilities="{ item }">
      <div class="text-right body-2 font-weight-black red--text">
        {{ item.liabilities | formatMoney }}
      </div>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { Lead } from '@/plugins/api'
import utils from '@/plugins/utils.js'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
export default {
  components: { AutocompleteStudent },
  data() {
    return {
      loading: false,
      student: {},
      singleSelect: false,
      selected: [],
      headers: [
        { text: 'Mã hóa đơn', align: 'start', sortable: false, value: 'code' },
        { text: 'Mô tả', value: 'tags' },
        { text: 'Đơn Giá', align: 'end', value: 'total' },
        { text: 'Cần đóng', align: 'end', value: 'liabilities' }
      ],
      leads: []
    }
  },
  created() {},
  computed: {
    ...mapGetters('app', ['department']),
    ...mapGetters('auth', ['profile'])
  },
  methods: {
    ...mapActions('sale', ['createBill', 'createLead']),
    async selectStudent(student) {
      this.student = student
      this.loading = true
      this.leads = await Lead.fetch({
        status: 'liabilities',
        student: student.id,
        _sort: 'date:DESC'
      })
      this.loading = false
    },
    selectLead(lead) {
      this.$emit('update:lead', lead)
      this.$emit('update:student', this.student)
    }
  },
  filters: {
    formatMoney(data) {
      return utils.formatMoney(data)
    }
  }
}
</script>
